import { Batch } from '@/models/Batch';
import { Shed } from '@/models/Shed';
import {
  getShedDetails,
  getSheds,
  getRationPrediction,
  getBatchDetails,
  getBatchConsumptionHistory,
  editShed,
  editBatch,
  getLineages,
  getSexes,
  getProductionTypes,
  getBreedingTypes,
  postBatch,
  getMortality,
  createMortality,
  updateMortality,
} from '@/services/environments';
import { getSiloOccupationHistory } from '@/services/nutrition';

export const actions = {
  async loadSheds({ rootGetters, commit }, { state = null, params = [], page, itemsPerPage }) {
    const token = rootGetters['user/getToken'];
    const category = rootGetters['environmentFilter/getCategory'];
    let sheds = new Array();
    commit('SET_SHEDS', []);
    commit('SET_SHEDS_IS_LOADED', false);

    if (params.production_type__external_id.length == 0) {
      params.production_type__external_id = {
        'matrix': '1,2',
        'broiler': '3',
        'laying-birds': '6,7',
        'swine': '5',
      }[category];
    }

    let response = await getSheds(
      token.access,
      itemsPerPage,
      (page - 1) * itemsPerPage,
      params,
      state
    );

    if (response.results) {
      response.results.forEach((element) => {
        let shed = Shed.fromApi(element);
        sheds.push(shed);
      });
    }
    commit('SET_SHEDS', sheds);
    commit('SET_TOTAL_SHEDS', response.count);
    commit('SET_SHEDS_IS_LOADED', true);
  },

  async loadShedDetails({ rootGetters, commit }, id) {
    const token = rootGetters['user/getToken'];

    let response = await getShedDetails(token.access, id);
    let shed = Shed.fromApi(response);

    commit('SET_SELECTED_SHED', shed);
  },

  async loadRationPrediction({ commit, rootGetters }, { id, params }) {
    const token = rootGetters['user/getToken'];
    const data = await getRationPrediction(token, id, params);
    commit('SET_RATION_PREDICTION', data);
  },

  async loadBatchDetails({ rootGetters, commit }, { id, state = null }) {
    const token = rootGetters['user/getToken'];

    const response = await getBatchDetails(token.access, id, state);

    const batch = Batch.fromApi(response);

    commit('SET_SELECTED_BATCH', batch);
  },

  async loadBatchConsumptionHistory({ rootGetters, commit }, params) {
    const token = rootGetters['user/getToken'];
    let batch = rootGetters['environment/getSelectedBatch'];

    const response = await getBatchConsumptionHistory(token.access, batch.id, params);

    commit('SET_SELECTED_BATCH_CONSUMPTION_HISTORY', response);
  },

  async editShed({ rootGetters }, shedData) {
    try {
      const token = rootGetters['user/getToken'];
      const { id, ...payload } = shedData;
      const response = await editShed(token, id, payload);
      return response;
    } catch (error) {
      console.error('Erro ao editar shed:', error);
      throw error;
    }
  },

  async editBatch({ rootGetters }, batchData) {
    try {
      const token = rootGetters['user/getToken'];
      const { id, ...payload } = batchData;
      const response = await editBatch(token, id, payload);
      return response;
    } catch (error) {
      console.error('Erro ao editar batch:', error);
      throw error;
    }
  },

  async loadLineages({ commit, rootGetters }, params) {
    const token = rootGetters['user/getToken'];
    const data = await getLineages(token, params);
    commit('SET_LINEAGES', data.results);
  },

  async loadSexes({ commit, rootGetters }, params) {
    const token = rootGetters['user/getToken'];
    const data = await getSexes(token, params);
    commit('SET_SEXES', data.results);
  },

  async loadProductionTypes({ commit, rootGetters }, params) {
    const token = rootGetters['user/getToken'];
    const data = await getProductionTypes(token, params);
    commit('SET_PRODUCTION_TYPE', data.results);
  },

  async loadBreedingTypes({ commit, rootGetters }, params) {
    const token = rootGetters['user/getToken'];
    const data = await getBreedingTypes(token, params);
    commit('SET_BREEDING_TYPE', data.results);
  },

  async sendBatch({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await postBatch(token.access, data);
  },

  async loadMortality({ commit, rootGetters }, params) {
    const token = rootGetters['user/getToken'];
    const data = await getMortality(token, params);
    commit('SET_MORTALITY', data.results);
  },

  async sendMortality({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await createMortality(token.access, data);
  },

  async updateMortality({ rootGetters }, data) {
    try {
      const token = rootGetters['user/getToken'];
      const { id, ...payload } = data;
      const response = await updateMortality(token, id, payload);
      return response;
    } catch (error) {
      console.error('Erro ao editar batch:', error);
      throw error;
    }
  },

  async loadBatchSiloOccupationHistory({ rootGetters, commit }, params) {
    const token = rootGetters['user/getToken'];
    const { id } = params;
    delete params.id;

    commit('SET_BATCH_SILO_OCCUPATION_HISTORY', { siloId: id, history: [] });

    const response = await getSiloOccupationHistory(token.access, id, params);

    commit('SET_BATCH_SILO_OCCUPATION_HISTORY', { siloId: id, history: response });
  },
};
